export const BRAND = {
  name: "Tapping Into Life LLC",
  tagline: "Discovering all of you",
  logo: "https://customer-assets.emergentagent.com/job_dff330c7-4b4c-4705-abfd-22e6e74f7c48/artifacts/63r03697_Tapping%20Into%20Life%20llc%20Logo%202026.jpg",
  podcastLinks: {
    spotify:
      "https://open.spotify.com/show/7ApJ8RIyZNarnZQtBeXiik?si=XYPzUD5USSqEJQGY_CCadg",
    youtube: "https://www.youtube.com/@tappingintolife/podcasts",
    youtubeMusic:
      "https://music.youtube.com/playlist?list=PLOxzXfYdUnKm_Kjy5h433O32ImH4Mvh8P&si=4xeEAeZ-KmOttYOq",
  },
  social: {
    instagram: "https://www.instagram.com/tapping_into_life/",
    facebook: "https://facebook.com/tappingintolifellc",
    spotify:
      "https://open.spotify.com/show/7ApJ8RIyZNarnZQtBeXiik?si=XYPzUD5USSqEJQGY_CCadg",
    tiktok:
      "https://www.tiktok.com/@tappingintolife?is_from_webapp=1&sender_device=pc",
  },
  email: "tappingintolifellc@gmail.com",
};

export const FOUNDER = {
  name: "Matthew Barlow",
  born: "January 31st, 1991 · Alexandria, VA",
  raisedIn: "North Carolina",
  credentials: [
    { label: "Certified", value: "Spiritual Life Coach" },
    { label: "Certified", value: "Trauma Coach" },
    { label: "Serving as", value: "Ordained Elder · 5+ yrs" },
  ],
  bio: [
    "Matthew was born on January 31st, 1991 in Alexandria, VA, and raised in the state of North Carolina. He is a certified Spiritual Life Coach and Trauma Coach, and has been an Ordained Elder for the past five years.",
    "Matthew has spent numerous years studying Spiritual Christianity. With the knowledge obtained, he built Tapping Into Life LLC on the firm belief that one's greatness starts with knowing who you are as a creation of God — your spiritual identity — and acknowledging how life experiences shape human-nature: spiritual discovery, identifying trauma, healing, life balance, and spiritual formation.",
    "His life purpose and calling are teaching and guiding people to greatness — and to being who God created them to be.",
  ],
};

export const SERVICES = [
  {
    id: "one-on-one",
    name: "One-on-One Virtual Spiritual Life Coaching",
    duration: "Per session · Virtual",
    price: "$75 / hr",
    blurb:
      "A private, one-on-one container to uncover your spiritual identity, walk through trauma with care, and step into the life God created you to live.",
    bullets: [
      "Personal spiritual-identity discovery",
      "Trauma-aware, faith-rooted coaching",
      "Life balance & spiritual formation guidance",
    ],
    accent: "#E67E22",
    featured: true,
  },
  {
    id: "group",
    name: "Group Sessions · In-Person & Virtual",
    duration: "Per session · Small group",
    price: "$125 / hr",
    blurb:
      "Walk this work alongside others. Small-group spiritual life coaching available in-person or virtually — community-grounded, Spirit-led.",
    bullets: [
      "Available in-person or virtually",
      "Spirit-led group discussion",
      "Shared healing & accountability",
    ],
    accent: "#D4AF37",
  },
];

export const EPISODES = [
  {
    id: "ep-12",
    number: "012",
    title: "The Quiet Power of Choosing Yourself First",
    duration: "42 min",
    date: "Nov 2025",
    summary:
      "We unpack the cultural noise around 'selfishness' and reframe self-care as the deepest service.",
  },
  {
    id: "ep-11",
    number: "011",
    title: "Tapping Through Grief: A Living Conversation",
    duration: "58 min",
    date: "Oct 2025",
    summary:
      "A tender, honest conversation about loss and how the work of inner discovery can softly meet the body where it hurts.",
  },
  {
    id: "ep-10",
    number: "010",
    title: "Roots Down, Branches Up — Building a Grounded Life",
    duration: "37 min",
    date: "Oct 2025",
    summary:
      "A reflection on the Tree of Life as a daily practice — staying rooted while reaching for what's next.",
  },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Maya R.",
    role: "Yoga Teacher · Asheville, NC",
    avatar:
      "https://images.unsplash.com/photo-1474176857210-7287d38d27c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMGZhY2UlMjBzbWlsaW5nJTIwY2FsbXxlbnwwfHx8fDE3ODE5NjIyNTR8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "I came in thinking I needed a strategy. I left with my own breath back. The work Matthew guided me through cracked something open I'd been carrying for years.",
  },
  {
    id: "t2",
    name: "Jordan L.",
    role: "Founder · Soft Bloom Studio",
    avatar:
      "https://images.unsplash.com/photo-1623717217554-72ca676de535?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxwb3J0cmFpdCUyMGZhY2UlMjBzbWlsaW5nJTIwY2FsbXxlbnwwfHx8fDE3ODE5NjIyNTR8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "Working with Matthew is the most generous thing I've done for the version of me running this business. I show up calmer, kinder, more rooted.",
  },
  {
    id: "t3",
    name: "Priya S.",
    role: "Therapist · Brooklyn, NY",
    avatar:
      "https://images.pexels.com/photos/10194768/pexels-photo-10194768.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "This is coaching that actually feels like ceremony. The group sessions gave me a community of people who see all of me — including the parts I'd hidden.",
  },
];

export const MEDIA = {
  hero_bg:
    "https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxoZWFsaW5nJTIwbmF0dXJlJTIwYWJzdHJhY3QlMjBkYXJrfGVufDB8fHx8MTc4MTk2MjI1NXww&ixlib=rb-4.1.0&q=85",
  coach:
    "https://customer-assets.emergentagent.com/job_tapping-brand/artifacts/bm2nyu9m_20260509_121418%281%29.jpg",
  podcast:
    "https://customer-assets.emergentagent.com/job_tapping-brand/artifacts/qfw24j45_2026%20tapping%20podcast%20logo.jpg",
};
